import React from "react";
import { Footer } from "./Footer";
import { Header } from "./Header";
import "./Layout.scss";

export const Layout = ({ children }) => {
  return (
    <div className="wrapper">
      <Header />
      <main>{children}</main>
      <Footer />
    </div>
  );
};
